var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ControlCenterLayout',{attrs:{"type":"api"}},[_c('BaseLayout',[_c('div',{staticClass:"lg:tw-mt-8 tw-mt-5 tw-flex tw-w-full tw-gap-4"},[_c('ApiMenu',{staticClass:"tw-hidden md:tw-block"}),_c('div',{staticClass:"tw-flex-1 app-main lg:tw-mb-0 tw-mb-4"},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }